import script from "./UsersTableTabComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsersTableTabComponent.vue?vue&type=script&lang=ts&setup=true"

import "./UsersTableTabComponent.vue?vue&type=style&index=0&id=4bcc68b2&lang=scss"

const __exports__ = script;

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QField from 'quasar/src/components/field/QField.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QInput,QIcon,QTd,QField,QCheckbox,QLinearProgress});
